module.exports = __webpack_public_path__ + "img/trip-bg.71990147.jpg";